import { Laya } from "../../Laya";
import { Render2DProcessor } from "../display/Render2DProcessor";
import { TextureMergeShaderInit } from "./shader/TextureMergeShaderInit";
import { Texture2D } from "../resource/Texture2D";
import { AutoTextureConfig } from "./AutoTextureConfig";
import { DynamicAtlasManager } from "./DynamicAtlasManager";
import { LayaGL } from "../layagl/LayaGL";
export class TextureProcessorAdapter {
    constructor() {
        this._dynamicAtlas = null;
        if (AutoTextureConfig.enableAutoDynamicAtlas) {
            this._dynamicAtlas = new DynamicAtlasManager(undefined, true);
        }
    }
    addTexture(texture) {
        var _a;
        if (this.shouldAddToDynamicAtlas(texture)) {
            (_a = this._dynamicAtlas) === null || _a === void 0 ? void 0 : _a.addTexture(texture);
        }
    }
    shouldAddToDynamicAtlas(texture) {
        if (!AutoTextureConfig.enableAutoDynamicAtlas) {
            return false;
        }
        const bitmap = texture.bitmap;
        if (!(bitmap instanceof Texture2D)) {
            return false;
        }
        return bitmap.width < AutoTextureConfig.limitDynamicAtlasSize &&
            bitmap.height < AutoTextureConfig.limitDynamicAtlasSize;
    }
    onUpdate() {
        var _a;
        (_a = this._dynamicAtlas) === null || _a === void 0 ? void 0 : _a.onUpdate();
    }
    cleanupUnused() {
        var _a;
        (_a = this._dynamicAtlas) === null || _a === void 0 ? void 0 : _a.cleanupUnusedTextures();
    }
}
export class LargeTexProcessor {
    constructor() {
        this.mgrs = [];
    }
    static addMgr(mgr) {
        this._instance.addManager(mgr);
    }
    static removeMgr(mgr) {
        this._instance.removeManager(mgr);
    }
    static cleanupUnused() {
        this._instance._textureProcessor.cleanupUnused();
    }
    get textureProcessor() {
        return this._textureProcessor;
    }
    setTextureProcessor(processor) {
        this._textureProcessor = processor;
    }
    addManager(mgr) {
        this.mgrs.push(mgr);
        if (this.mgrs.length === 1) {
            Laya.stage.timer.loop(200, this, this.update);
        }
    }
    removeManager(mgr) {
        this.mgrs.splice(this.mgrs.indexOf(mgr), 1);
        if (this.mgrs.length === 0) {
            Laya.stage.timer.clear(this, this.update);
        }
    }
    update(force = false) {
        if (!force && Laya.stage.getTimeFromFrameStart() > 100)
            return;
        const ary = this.mgrs;
        let n = ary.length;
        for (let i = 0; i < n; i++) {
            const o = ary[i];
            if (!o)
                continue;
            o.onUpdate();
            if (!force && Laya.stage.getTimeFromFrameStart() > 30)
                break;
        }
        if (ary.length != n)
            ary.length = n;
    }
}
Laya.addAfterInitCallback(() => {
    let objectName = LayaGL.renderEngine.objectName ? LayaGL.renderEngine.objectName : '';
    let isWebGPU = !!objectName.includes('GPU');
    if (isWebGPU) {
        AutoTextureConfig.enableAutoDynamicAtlas = true;
    }
    TextureMergeShaderInit.init();
    let processor = LargeTexProcessor._instance = new LargeTexProcessor();
    let textureProcessor = new TextureProcessorAdapter();
    processor.setTextureProcessor(textureProcessor);
    Render2DProcessor.runner._textureProcessor = textureProcessor;
});
